import React from 'react'
import PorEmpleado from './porEmpleados/index'
import EpicMenu from '../../componentes/Menus/EpicMenu'
import './styles.css'

const PiscaRoutes = () => {
    return (
        <section className='piscaPage'>
            <div className='header'>
				<EpicMenu />
				<div className='inline'>Pisca</div>
			</div>
            <main className='piscaContent'>
                <PorEmpleado />
            </main>
            <div className="footer" >
				<div className="footer1" ></div>
				<div className="footer2" ></div>
			</div>
        </section>
    )
}

export default PiscaRoutes
